import {ConductorDTO} from "../conductor.dto";
import {BaseResponseDTO} from "./base.response.dto";


export class GetDetalleConductorResponseDTO extends BaseResponseDTO {

    success: boolean;
    msg: string;
    data: ConductorDTO;

  }
